export default __webpack_public_path__ + "static/media/classic-logo.90489d43.jpg";